import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { Movement } from '../models/movement.entity';

const BASE_URL = 'movements';

@Injectable({
  providedIn: 'root',
})
export class MovementsService {
  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   */
  constructor(private apiService: ApiService) {
    this.loading$ = this.apiService.loading$;
  }

  /**
   * Get
   *
   * @param id Id of movement
   */
  get(id: string): Observable<Movement> {
    return this.apiService.get(`${BASE_URL}/${id}`).pipe(map((movement: Movement) => Movement.create(movement)));
  }

  /**
   * List movements
   */
  list(): Observable<Movement[]> {
    return this.apiService.get(BASE_URL).pipe(map((movements) => movements.map((movement: any) => Movement.create(movement))));
  }

  /**
   * Create
   *
   * @param movement Movement instance
   */
  create(movement: Movement): Observable<any> {
    return this.apiService.post(BASE_URL, movement);
  }

  /**
   * Update
   *
   * @param movement Movement instance
   */
  update(movement: Movement): Observable<any> {
    const movementId = movement.movementId;
    const movementUpdate = Movement.create(movement);
    delete movement.movementId;
    delete movement.createdAt;
    return this.apiService.patch(`${BASE_URL}/${movementId}`, movementUpdate);
  }

  /**
   * Delete
   *
   * @param id Primary key
   */
  delete(id: number): Observable<any> {
    return this.apiService.delete(`${BASE_URL}/${id}`);
  }

  /**
   * Find filtered
   *
   * @param queryOptions Object with query options
   */
  findFiltered(queryOptions: any): Observable<Movement[]> {
    return this.apiService
      .post(`${BASE_URL}/list`, queryOptions)
      .pipe(map((movements) => movements.map((movement: any) => Movement.create(movement))));
  }

  /**
   * Get count for filter
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Filter object
   */
  // tslint:disable-next-line:max-line-length
  getCount(
    order: string = 'movementId',
    sort: string = 'desc',
    limit: number = 10,
    page: number = 0,
    filter: object = { endDate: null }
  ): Observable<any> {
    const options = { order, sort, limit, page };
    for (const i in filter) {
      if (filter.hasOwnProperty(i) && filter[i] === '') {
        delete filter[i];
      }
    }
    return this.apiService.post(`${BASE_URL}/count`, { ...options, ...filter });
  }

  getDoors() {
    return this.apiService.get(`${BASE_URL}/doors`);
  }
}
